import _regeneratorRuntime from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _toConsumableArray from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/data/home/fjc/workspace/tfjs-yolov5-example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @license
 * Copyright 2018 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */
import { ENGINE } from '../engine';
import { dispose as _dispose, tidy } from '../globals';
import { add } from '../ops/add';
import { div } from '../ops/div';
import { mul } from '../ops/mul';
import { pow } from '../ops/pow';
import { scalar } from '../ops/scalar';
import { sqrt } from '../ops/sqrt';
import { square } from '../ops/square';
import { sub } from '../ops/sub';
import { zerosLike } from '../ops/zeros_like';
import { registerClass } from '../serialization';
import { Optimizer } from './optimizer';
export var AdamOptimizer = /*#__PURE__*/function (_Optimizer) {
  _inherits(AdamOptimizer, _Optimizer);

  function AdamOptimizer(learningRate, beta1, beta2) {
    var _this;

    var epsilon = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    _classCallCheck(this, AdamOptimizer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AdamOptimizer).call(this));
    _this.learningRate = learningRate;
    _this.beta1 = beta1;
    _this.beta2 = beta2;
    _this.epsilon = epsilon;
    _this.accumulatedFirstMoment = [];
    _this.accumulatedSecondMoment = [];
    tidy(function () {
      // accB* will be updated by batch.
      _this.accBeta1 = scalar(beta1).variable();
      _this.accBeta2 = scalar(beta2).variable();
    });

    if (epsilon == null) {
      _this.epsilon = ENGINE.backend.epsilon();
    }

    return _this;
  }

  _createClass(AdamOptimizer, [{
    key: "applyGradients",
    value: function applyGradients(variableGradients) {
      var _this2 = this;

      var varNames = Array.isArray(variableGradients) ? variableGradients.map(function (v) {
        return v.name;
      }) : Object.keys(variableGradients);
      tidy(function () {
        var oneMinusAccBeta1 = sub(1, _this2.accBeta1);
        var oneMinusAccBeta2 = sub(1, _this2.accBeta2);
        varNames.forEach(function (name, i) {
          var value = ENGINE.registeredVariables[name];
          var trainable = false;

          if (_this2.accumulatedFirstMoment[i] == null) {
            _this2.accumulatedFirstMoment[i] = {
              originalName: "".concat(name, "/m"),
              variable: tidy(function () {
                return zerosLike(value).variable(trainable);
              })
            };
          }

          if (_this2.accumulatedSecondMoment[i] == null) {
            _this2.accumulatedSecondMoment[i] = {
              originalName: "".concat(name, "/v"),
              variable: tidy(function () {
                return zerosLike(value).variable(trainable);
              })
            };
          }

          var gradient = Array.isArray(variableGradients) ? variableGradients[i].tensor : variableGradients[name];

          if (gradient == null) {
            return;
          }

          var firstMoment = _this2.accumulatedFirstMoment[i].variable;
          var secondMoment = _this2.accumulatedSecondMoment[i].variable;
          var newFirstMoment = add(mul(firstMoment, _this2.beta1), mul(gradient, 1 - _this2.beta1));
          var newSecondMoment = add(mul(secondMoment, _this2.beta2), mul(square(gradient), 1 - _this2.beta2));
          var biasCorrectedFirstMoment = div(newFirstMoment, oneMinusAccBeta1);
          var biasCorrectedSecondMoment = div(newSecondMoment, oneMinusAccBeta2);
          firstMoment.assign(newFirstMoment);
          secondMoment.assign(newSecondMoment);
          var newValue = add(mul(div(biasCorrectedFirstMoment, add(sqrt(biasCorrectedSecondMoment), _this2.epsilon)), -_this2.learningRate), value);
          value.assign(newValue);
        });

        _this2.accBeta1.assign(mul(_this2.accBeta1, _this2.beta1));

        _this2.accBeta2.assign(mul(_this2.accBeta2, _this2.beta2));
      });
      this.incrementIterations();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.accBeta1.dispose();
      this.accBeta2.dispose();

      if (this.accumulatedFirstMoment != null) {
        _dispose(this.accumulatedFirstMoment.map(function (v) {
          return v.variable;
        }));
      }

      if (this.accumulatedSecondMoment != null) {
        _dispose(this.accumulatedSecondMoment.map(function (v) {
          return v.variable;
        }));
      }
    }
  }, {
    key: "getWeights",
    value: function () {
      var _getWeights = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var variables;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // Order matters for Python compatibility.
                variables = [].concat(_toConsumableArray(this.accumulatedFirstMoment), _toConsumableArray(this.accumulatedSecondMoment));
                _context.next = 3;
                return this.saveIterations();

              case 3:
                _context.t0 = _context.sent;
                return _context.abrupt("return", [_context.t0].concat(variables.map(function (v) {
                  return {
                    name: v.originalName,
                    tensor: v.variable
                  };
                })));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getWeights() {
        return _getWeights.apply(this, arguments);
      }

      return getWeights;
    }()
  }, {
    key: "setWeights",
    value: function () {
      var _setWeights = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(weightValues) {
        var _this3 = this;

        var variableCount, trainable;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.extractIterations(weightValues);

              case 2:
                weightValues = _context2.sent;
                tidy(function () {
                  _this3.accBeta1.assign(pow(_this3.beta1, _this3.iterations_ + 1));

                  _this3.accBeta2.assign(pow(_this3.beta2, _this3.iterations_ + 1));
                });
                variableCount = weightValues.length / 2;
                trainable = false;
                this.accumulatedFirstMoment = weightValues.slice(0, variableCount).map(function (v) {
                  return {
                    originalName: v.name,
                    variable: v.tensor.variable(trainable)
                  };
                });
                this.accumulatedSecondMoment = weightValues.slice(variableCount, variableCount * 2).map(function (v) {
                  return {
                    originalName: v.name,
                    variable: v.tensor.variable(trainable)
                  };
                });

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setWeights(_x) {
        return _setWeights.apply(this, arguments);
      }

      return setWeights;
    }()
  }, {
    key: "getConfig",
    value: function getConfig() {
      return {
        'learningRate': this.learningRate,
        'beta1': this.beta1,
        'beta2': this.beta2,
        'epsilon': this.epsilon
      };
    }
    /** @nocollapse */

  }], [{
    key: "fromConfig",
    value: function fromConfig(cls, config) {
      return new cls(config['learningRate'], config['beta1'], config['beta2'], config['epsilon']);
    }
  }]);

  return AdamOptimizer;
}(Optimizer);
/** @nocollapse */

AdamOptimizer.className = 'Adam'; // Note: Name matters for Python compatibility.

registerClass(AdamOptimizer);